import styled, { css } from 'styled-components';
import {
  variant,
  color,
  fontWeight,
  fontFamily,
  fontStyle,
  textAlign,
  FontWeightProps,
  FontStyleProps,
  LineHeightProps,
  FontFamilyProps,
  ColorProps,
  TextAlignProps,
  lineHeight,
} from 'styled-system';
import CSS from 'csstype';

import { ThemeUtilities } from '../../../theme';

import { BodyTextVariant } from './types';
import { fontSmoothing } from '../../../mixins';

type TextProps = {
  variant: BodyTextVariant;
  overflow: 'truncate' | 'break-word';
  whiteSpace?: CSS.Property.WhiteSpace;
} & FontWeightProps &
  FontStyleProps &
  FontFamilyProps &
  ColorProps &
  LineHeightProps &
  TextAlignProps;

export const Text = styled.p<TextProps>`
  margin: 0;
  padding: 0;
  ${fontSmoothing};
  ${color};
  ${fontStyle};
  ${fontFamily};
  ${fontWeight};
  ${textAlign};
  ${(props) =>
    props.whiteSpace &&
    css`
      white-space: ${props.whiteSpace};
    `};
  ${(props) =>
    props.overflow === 'truncate' &&
    css`
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    `};

  ${(props) =>
    props.overflow === 'break-word' &&
    css`
      overflow-wrap: break-word;
    `};

  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'BodyText', 'variant'))};
  ${css((props) => ThemeUtilities.getComponentCSSOverrides(props, 'BodyText'))};
  ${lineHeight};
`;
